import { flatMap, catchError } from "rxjs/operators";
import { push } from "connected-react-router";
import { combineEpics, ofType } from "redux-observable";
import { Observable } from "rxjs-compat";
import App from "../../lib/app.js";
import LoginActions from "../reducers/login.reducer";
import InvestorsActions from "../reducers/investors.reducer";
import { investorsSerializer } from "../../lib/serializers/investors.serializer";
import { forkJoin } from "rxjs";

export const StartInvestorsShowcase = () => ({
  type: "START_INVESTORS_SHOWCASE",
});

export const startGetQualifiedInvestors = () => ({
  type: "SUBMIT_GET_QUALIFIED_INVESTORS",
});

export const submitGetQualifiedInvestors = (action$) =>
  action$.pipe(
    ofType("SUBMIT_GET_QUALIFIED_INVESTORS"),
    flatMap((action) => {
      return Observable.from(App.api.a2censo.listQualifiedInvestors()).pipe(
        flatMap((response) => {
          let investors = [];
          let documents = [];
          
          if (response?.data?.investors) {
            investors = response.data.investors;
            documents = response.data.documents || [];
          } else if (response?.investors) {
            investors = response.investors;
            documents = response.documents || [];
          } else if (Array.isArray(response)) {
            investors = response;
          }
          
          return Observable.of(
            InvestorsActions.getQualifiedInvestorsSuccess({ investors, documents })
          );
        }),
        catchError((error) => {
          if (error.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.of(
              InvestorsActions.getQualifiedInvestorsError(
                error?.data?.message ||
                  error?.message ||
                  "Error al obtener inversionistas calificados"
              )
            );
          }
        })
      );
    })
  );

export const submitUpdateInvestorState = (action$) =>
  action$.pipe(
    ofType("SUBMIT_UPDATE_INVESTOR_STATE"),
    flatMap((action) => {
      const { investorId, payload } = action;

      let fileName = "";
      if (payload.soporte) {
        const originalFileName = payload.soporte.name;
        const fileExtension = originalFileName.split(".").pop();
        const fileNameWithoutExt =
          originalFileName.substring(0, originalFileName.lastIndexOf(".")) ||
          originalFileName;
        fileName = `${fileNameWithoutExt}.${fileExtension}`;
      }

      const requestBody = {
        data: {
          attributes: {
            id: investorId,
            state: payload.estado_inversionista,
            expiration_date: payload.fecha_expiracion || "",
            file_: fileName,
            observation: payload.justificacion || "",
            user_email: payload.user_email || "",
            user_ip: payload.user_ip || "",
          },
        },
      };

      return Observable.from(
        App.api.a2censo.updateQualifiedInvestor({ body: requestBody })
      ).pipe(
        flatMap((response) => {
          if(response.urlPresigned) {
            const file = payload.soporte;
            
            return Observable.from(
              fetch(response.urlPresigned, {
                method: "PUT",
                body: file,
              })
              .then((s3Response) => {
                if (!s3Response.ok) {
                  throw new Error(`Error al subir el archivo al S3: ${s3Response.status} ${s3Response.statusText}`);
                }
                
                return response;
              })
              .catch((error) => {
                throw error;
              })
            ).pipe(
              flatMap((res) => {
                return Observable.of(
                  InvestorsActions.updateInvestorStateSuccess(
                    res?.data?.message ||
                      res?.message ||
                      "Estado actualizado correctamente"
                  )
                );
              }),
              catchError((error) => {
                console.error("Error al subir el archivo al S3:", error);
                return Observable.of(
                  InvestorsActions.updateInvestorStateError(
                    error.message || "Error al subir el archivo al S3"
                  )
                );
              })
            );
          }
        
          return Observable.of(
            InvestorsActions.updateInvestorStateSuccess(
              response?.data?.message ||
                response?.message ||
                "Estado actualizado correctamente"
            )
          );
        }),
        catchError((response) => {
          console.error("Error al actualizar inversionista:", response);
          if (response.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.of(
              InvestorsActions.updateInvestorStateError(
                response?.data?.message ||
                  response?.message ||
                  "Error al modificar el estado del inversionista"
              )
            );
          }
        })
      );
    })
  );

export const investorsShowcase = (action$) =>
  action$.pipe(
    ofType("START_INVESTORS_SHOWCASE"),
    flatMap((action) => {
      let request;
      request = forkJoin([Observable.from(App.api.a2censo.getAllInvestors())]);
      return request.pipe(
        flatMap((response) => {
          const investorList = response[0];
          return Observable.of(push(`/investors`, { investorList }));
        }),
        catchError((response) => {
          if (response.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.concat(Observable.of(push(`oops`)));
          }
        })
      );
    })
  );

export const submitGetAllCitiesInTheWorld = (action$) =>
  action$.pipe(
    ofType("SUBMIT_GET_ALL_CITIES_IN_THE_WORLD"),
    flatMap((action) => {
      return Observable.from(App.api.a2censo.getAllCitiesInTheWorld()).pipe(
        flatMap((response) => {
          return Observable.of(
            InvestorsActions.getAllCitiesInTheWorldSuccess(response)
          );
        }),
        catchError((response) => {
          if (response.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.concat(Observable.of(push(`oops`)));
          }
        })
      );
    })
  );

export const submitGetInvestorById = (action$) =>
  action$.pipe(
    ofType("SUBMIT_GET_INVESTOR_BY_ID"),
    flatMap((action) => {
      const url = {
        investor_id: action.investor_id,
      };
      return Observable.from(App.api.a2censo.getInvestorById({ url })).pipe(
        flatMap((response) => {
          return Observable.of(
            InvestorsActions.getInvestorByIdSuccess(response)
          );
        }),
        catchError((response) => {
          if (response.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.concat(Observable.of(push(`oops`)));
          }
        })
      );
    })
  );

export const updateInfoInvestors = (action$) =>
  action$.pipe(
    ofType("SUBMIT_UPDATE_INFO_INVESTORS"),
    flatMap((action) => {
      const file = action.file;
      const file_name = action.file_name;
      const investor_id = action.investor_id;
      const deposit_account = action.deposit_account;
      const city_id = action.city_id;
      const city_name = action.city_name;
      const observation = action.observation;
      const user_email = action.user_email;
      const user_ip = action.user_ip;
      const data = {
        body: investorsSerializer().serialize({
          file,
          file_name,
          investor_id,
          deposit_account,
          city_id,
          city_name,
          observation,
          user_email,
          user_ip,
        }),
      };
      return Observable.from(
        App.api.a2censo.updateInfoInvestors({ ...data })
      ).pipe(
        flatMap((response) => {
          return Observable.of(
            InvestorsActions.updateInfoInvestorsSuccess(response?.message)
          );
        }),
        catchError((response) => {
          if (response.statusCode === 401) {
            return Observable.of(LoginActions.submitLogout());
          } else {
            return Observable.concat(
              Observable.of(
                InvestorsActions.updateInfoInvestorsError(
                  response?.data?.attributes?.message
                )
              )
            );
          }
        })
      );
    })
  );

export const submitReviewSupport = (action$) =>
  action$.pipe(
    ofType("SUBMIT_REVIEW_SUPPORT"),
    flatMap((action) => {
      return Observable.from(App.api.a2censo.reviewSupport()).pipe(
        flatMap((response) => {
          return Observable.of({ type: "REVIEW_SUPPORT_SUCCESS" });
        }),
        catchError((error) => {
          return Observable.of({ type: "REVIEW_SUPPORT_ERROR" });
        })
      );
    })
  );

export default combineEpics(
  investorsShowcase,
  submitGetQualifiedInvestors,
  submitUpdateInvestorState,
  submitReviewSupport,
  submitGetInvestorById,
  updateInfoInvestors,
  submitGetAllCitiesInTheWorld
);
